export default "__VITE_ASSET__472b37cf__$_?component__"